var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "templateItem",
    {
      ref: "column",
      attrs: {
        metadata: _vm.metadata,
        isSelected: _vm.isSelected,
        parentId: _vm.parentId,
        isParent: _vm.isParent,
        hideSort: true,
        controlsClass: "top",
        classes: _vm.classes,
        styles: _vm.style,
        locked: _vm.locked
      },
      on: {
        "delete-item": function($event) {
          return _vm.$emit("delete-column", $event)
        },
        "select-item": function($event) {
          return _vm.$emit("select-column", $event)
        },
        "lock-item": function($event) {
          return _vm.$emit("lock-column", $event)
        }
      }
    },
    [
      _vm.showSettings
        ? [
            _c("template-column-settings", {
              model: {
                value: _vm.model,
                callback: function($$v) {
                  _vm.model = $$v
                },
                expression: "model"
              }
            }),
            _vm._v(" "),
            _vm.isButton
              ? _c("template-column-button-settings", {
                  model: {
                    value: _vm.contentSettingsModel,
                    callback: function($$v) {
                      _vm.contentSettingsModel = $$v
                    },
                    expression: "contentSettingsModel"
                  }
                })
              : _vm.isText
              ? _c("template-column-text-settings", {
                  attrs: { "column-rect": _vm.columnRect },
                  model: {
                    value: _vm.contentSettingsModel,
                    callback: function($$v) {
                      _vm.contentSettingsModel = $$v
                    },
                    expression: "contentSettingsModel"
                  }
                })
              : _vm.isImage
              ? _c("template-column-image-settings", {
                  model: {
                    value: _vm.contentSettingsModel,
                    callback: function($$v) {
                      _vm.contentSettingsModel = $$v
                    },
                    expression: "contentSettingsModel"
                  }
                })
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isButton
        ? _c("template-column-button-content", {
            attrs: { metadata: _vm.contentSettingsModel },
            on: {
              "text-changed": function($event) {
                _vm.contentSettingsModel.text = $event
              }
            }
          })
        : _vm.isText
        ? _c("template-column-text-content", {
            attrs: { metadata: _vm.contentSettingsModel },
            on: {
              "text-changed": function($event) {
                _vm.contentSettingsModel.text = $event
              }
            }
          })
        : _vm.isImage
        ? _c("template-column-image-content", {
            attrs: { metadata: _vm.contentSettingsModel }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }